import { enableProdMode, importProvidersFrom } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';


import { environment } from './environments/environment';
import { LoggedInGuard, LoggedOutGuard, AdminGuard, SystemGuard, OrganizationGuard, EnrolmentRedirectGuard, FormSubmissionsGuard, PermissionGuard, ConversationsRedirectGuard } from '@app/common/guards';
import { ErrorStateMatcher, ShowOnDirtyErrorStateMatcher } from '@angular/material/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AppRoutingModule } from './app/app-routing.module';
import { provideAnimations } from '@angular/platform-browser/animations';
import { CoreModule } from './app/core/core.module';
import { SideNavModule } from '@libs/layouts/side-nav';
import { FsProgressModule } from '@firestitch/progress';
import { AppComponent } from './app/app.component';
import { bootstrapApplication } from '@angular/platform-browser';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(AppRoutingModule, CoreModule, SideNavModule, FsProgressModule),
        LoggedInGuard,
        LoggedOutGuard,
        AdminGuard,
        SystemGuard,
        OrganizationGuard,
        EnrolmentRedirectGuard,
        FormSubmissionsGuard,
        PermissionGuard,
        ConversationsRedirectGuard,
        {
            provide: ErrorStateMatcher,
            useClass: ShowOnDirtyErrorStateMatcher,
        },
        provideHttpClient(withInterceptorsFromDi()),
        provideAnimations()
    ]
});
